import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lottery-odds',
  component: () => import('../../routes/LotteryOddsCalculator.svelte'),
  card: {
    id: 'lottery-odds',
    title: 'Lottery Odds Calculator',
    description: 'Calculate your odds of winning any lottery using combinatorics. See your chances of hitting the jackpot vs. matching fewer numbers.',
    icon: 'casino',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/lottery-odds',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Lottery Odds Calculator – Calculate Your Chances of Winning',
    description: 'Free lottery odds calculator using combinatorics. Calculate your exact probability of winning the jackpot or matching any number of balls. Works for Powerball, Mega Millions, and any custom lottery.',
  },
};

export default meta;
